/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
import React from "react";
import { CssBaseline, useMediaQuery } from "@mui/material";
import AppRoutes from "./components/Routes/Routes";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import { useThemeContext } from "./components/GeneralConfig";
import { useLocation } from "react-router-dom";

function App() {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const { darkMode, toggleTheme } = useThemeContext();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("profile");
    window.location.href = "/login";
  };

  // Verifica se a rota atual é /home, /privacy-policy ou /payment-status/:payment_id
  const hideNavbarAndFooter = ["/home", "/privacy-policy"].some(
    (path) =>
      location.pathname.startsWith(path) ||
      location.pathname.startsWith("/payment-status")
  );

  return (
    <>
      <CssBaseline />
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        {/* Renderiza o Navbar apenas se não estiver nas rotas /home ou /privacy-policy */}
        {!hideNavbarAndFooter && (
          <header>
            <Navbar
              isMobile={isMobile}
              darkMode={darkMode}
              toggleTheme={toggleTheme}
              handleLogout={handleLogout}
            />
          </header>
        )}
        <main
          style={{
            flex: "1",
            padding: "20px",
            backgroundColor: darkMode ? "#121212" : "#ffffff", // Garante o fundo do tema
            color: darkMode ? "#ffffff" : "#000000",
            minHeight: "100vh", // Garante que cobre toda a altura
          }}
        >
          <AppRoutes />
        </main>
        {/* Renderiza o Footer apenas se não estiver nas rotas /home ou /privacy-policy */}
        {!hideNavbarAndFooter && <Footer darkMode={darkMode} />}
      </div>
    </>
  );
}

export default App;
